<template>
  <page-with-back-btn title="Select Customer" :back="backButton">
    <div class="search-box shadow-sm d-flex py-1 px-3">
      <form @submit.prevent="getAllDebtors">
        <div class="row">
          <div class="col-md-3 d-flex flex-row">
            <div class="form-floating mx-1" style="width: 80%">
              <input type="text" class="form-control"
                     v-model="form.Name" id="customerName"
                     placeholder="Customer Name">
              <label for="customerName">Customer Name</label>
            </div>
            <button class="lyt-soft-btn h-100" style="width: 15%;" type="button" @click="createDebtor">
              <font-awesome-icon icon="fa-solid fa-plus"/>
            </button>
          </div>

          <div class="col-md-3">
            <div class="form-floating ">
              <input type="text" class="form-control"
                     v-model="form.tpin" id="customerTPIN"
                     placeholder="TPIN">
              <label for="customerTPIN">TPIN</label>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-floating ">
              <input type="text" class="form-control"
                     v-model="form.contact" id="customerContact"
                     placeholder="Contact No.">
              <label for="customerContact">Contact No.</label>
            </div>
          </div>

          <div class="col-md-2 d-flex align-items-center">
            <div class="form-check">
              <input type="checkbox" class="form-check-input"
                     v-model="form.isCash" id="cashCustomer">
              <label class="form-check-label" for="cashCustomer">Cash Customer</label>
            </div>
          </div>

          <div class="col-md-1 d-flex align-items-center">
            <button class="lyt-soft-btn w-100" type="submit">Search</button>
          </div>
        </div>
      </form>
    </div>

    <div class="text-center d-flex justify-content-between align-items-center px-3 m-2">
      <span>Sale Total :</span>
      <h3 class="fw-bold m-0">{{ $utils.formatMoney(saleTotal) }}</h3>
    </div>
    <div class="list-body h-100 w-100">
      <DebtorListItem v-for="item in debtors" :debtor="item" @click="chooseAction(item)"/>
    </div>

    <custom-modal title="Record Customer Payment" ref="accountPayment" :is-form="true" @submit="processAccountPayment">
      <span class="text-sm text-secondary mb-2">Customer : {{ paymentDetails.debtorName }}</span>
      <div class="mx-1 mb-2">
        <label for="payment_description">Payment Description</label>
        <input type="text" class="form-control" v-model="paymentDetails.Des" id="payment_description" required>
      </div>
      <div class="mx-1 mb-2">
        <label for="payment_amount">Payment Amount</label>
        <input type="text" class="form-control" v-model="paymentDetails.PayedAmount" id="payment_amount" required>
      </div>
      <div class="form-floating mx-1">
        <select class="form-select" id="paymentOptions" v-model="paymentDetails.PaymentType">
          <option value="Cash" >Cash</option>
          <option value="Card">Card</option>
          <option value="Kazang">Kazang</option>
          <option v-for="method in paymentMethods" :value="method.name">{{ method.name }}</option>
        </select>
        <label for="paymentOptions">Payment Type</label>
      </div>
    </custom-modal>
  </page-with-back-btn>
</template>

<script>
import DebtorListItem from "@/components/point-of-sale/Accounts/DebtorListItem";
import PageWithBackBtn from "@/components/layout/utils/PageWithBackBtn";
import CustomModal from "@/components/layout/utils/CustomModal";

export default {
  name: "SelectCustomer",
  components: {CustomModal, PageWithBackBtn, DebtorListItem},
  beforeMount() {
    this.getAllDebtors();
  },
  computed: {
    debtors() {
      return this.$store.getters.getDebtors
    },
    saleDetails() {
      return this.$store.getters.getSaleDetails
    },
    saleTotal() {
      return this.$store.getters.getSaleTotal
    },
    isASale() {
      return this.$store.getters.getSaleUnits;
    },
    paymentMethods() {
      return this.$store.getters.getPaymentMethods
          .filter(method => method.active)
          .filter(method => method.IsBaseCurrency);
    }
  },
  data() {
    return {
      loading: true,
      form: {
        Name: "",
        tpin: "",
        contact: "",
        isCash: false
      },
      saleNumber: this.$route.query.saleNumber,
      paymentDetails: {
        debId: null,
        debtorName: null,
        PayedAmount: null,
        Des: "Account Till Payment",
        PaymentType: null,
        datPay: this.$store.getters.currentTime.toString().replaceAll('T', ' ') + ':00',
      }
    }
  },
  methods: {
    getAllDebtors() {
      this.$utils.showLoading()
      return this.$store.dispatch('getAllDebtors', this.form)
          .finally(() => this.$utils.hideLoading());
    },

    chooseAction(debtor) {
      if (this.isASale) {
        this.$store.commit(`setCustomer`, debtor.Id);
        return this.saleActions(debtor);
      }
      return this.nonSaleActions(debtor);
    },

    nonSaleActions(debtor) {
      return Swal.fire({
        title: `Choose Action`,
        html: `<h6>Debtor : ${debtor.Name} ${debtor.Surname}</h6><br>
                 Balance : ${this.$utils.formatMoney(debtor.Balance)} `,
        showCancelButton: false,
        showDenyButton: false,
        confirmButtonText: 'Make Payment',
        showCloseButton: true,
        denyButtonText: `PrintStatement`,
        denyButtonColor: `rgb(88, 125, 224)`,
      }).then((result) => {
        if (result.isConfirmed) {
          return this.makeAccountPayment(debtor);
        }
      })
    },

    backButton() {
      return this.$router.push({
        name: 'pos',
        query: {
          saleNumber: this.saleNumber,
          dontReload: true,
        }
      });
    },

    saleActions(debtor) {
      return Swal.fire({
        title: `Choose Action <br><h6>Debtor : ${debtor.Name} ${debtor.Surname}</h6>`,
        showDenyButton: true,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: 'Quote',
        denyButtonText: `Add to Sale`,
        cancelButtonText: `Sell On Account`,
        denyButtonColor: `rgb(88, 125, 224)`,
        cancelButtonColor: `rgb(88, 125, 224)`,
      }).then((result) => {
        if (result.isConfirmed) {
          return this.quoteCustomer(debtor);
        } else if (result.isDenied) {
          this.$store.commit(`setCustomer`, debtor.Id);
          responses.showSuccess(`Customer ${debtor.Name} added Successfully`)
          return this.backButton();
        } else if (result.isDismissed && result.dismiss === `cancel`) {
          return this.processTransaction('AccountSale');
        }
      })
    },

    processTransaction(type) {
      this.$store.commit('setSaleDetails', {
        refund: false,
        reference: this.$store.getters.getOpenTableName,
        total: parseFloat(this.saleTotal.toFixed(2)),
        paid: parseFloat(this.saleTotal.toFixed(2)),
        change: 0
      });
      let obj = this.saleDetails;
      obj.type = type;
      return this.$store.dispatch("processTransaction", obj)
          .then((res) => {
            if (res) this.$router.push({name: 'viewPayment'})
          })
    },

    makeAccountPayment(debtor) {
      this.paymentDetails.debId = debtor.Id;
      this.paymentDetails.debtorName = debtor.Name;
      return this.$refs.accountPayment.openModal()
    },

    async processAccountPayment() {
      if (this.paymentDetails.PaymentType === 'Kazang') {
        return this.kazangAccountPayment(this.paymentDetails)
      }

      this.$utils.showLoading()
      try {
        const result = await this.$store.dispatch('makeDebtorPayment', this.paymentDetails);

        if (result && result.success && result.paymentId) {
          // Ask user if they want to print the receipt
          const printResult = await Swal.fire({
            title: 'Payment Successful!',
            text: 'Would you like to print the payment receipt?',
            icon: 'success',
            showCancelButton: true,
            confirmButtonText: 'Yes, Print Receipt',
            cancelButtonText: 'No, Thanks',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#6c757d'
          });

          if (printResult.isConfirmed) {
            await this.$store.dispatch('printPaymentReceipt', result.paymentId);
          }
        }

        // Navigate back to POS
        this.$router.push({ name: 'pos' });
      } catch (error) {
        console.error('Payment processing error:', error);
      } finally {
        this.$utils.hideLoading();
      }
    },

    kazangAccountPayment(payload) {
      return Swal.fire({
        title: 'Customer Phone No. ?',
        icon: 'question',
        input: 'number',
        showCancelButton: true,
        confirmButtonText: 'Process',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: (input) => {
          if (!input) return Swal.showValidationMessage(`Customer Phone No.`);
          payload.customerContact = input;
          return this.$store.dispatch('firstKazangAccountPaymentStep', payload)
              .then((res) => {
                if (res.Error) {
                  throw new Error(res.Error)
                } else {
                  res.paymentData = payload;
                  res.customerContact = input;
                  return res
                }
              }).catch(err => Swal.showValidationMessage(err))
        },
      }).then((result) => {
        if (result.isConfirmed) {
          return this.confirmKazangAccountPayment(result.value)
        }
      })
    },

    async confirmKazangAccountPayment(firstKazangStepResponse) {
      if (firstKazangStepResponse === "processed") {
        return this.backButton()
      }

      const result = await Swal.fire({
        title: 'Confirm Kazang Payment',
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Process',
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: () => {
          return this.$store.dispatch('secondKazangAccountPaymentStep', firstKazangStepResponse)
              .then((res) => {
                if (res.Error) throw new Error(res.Error)
                return res;
              })
              .catch(err => Swal.showValidationMessage(err))
        },
      });

      if (result.isConfirmed && result.value) {
        // Check if payment was successful and has payment ID
        if (result.value.success && result.value.paymentId) {
          // Ask user if they want to print the receipt
          const printResult = await Swal.fire({
            title: 'Kazang Payment Successful!',
            text: 'Would you like to print the payment receipt?',
            icon: 'success',
            showCancelButton: true,
            confirmButtonText: 'Yes, Print Receipt',
            cancelButtonText: 'No, Thanks',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#6c757d'
          });

          if (printResult.isConfirmed) {
            await this.$store.dispatch('printPaymentReceipt', result.value.paymentId);
          }
        }

        return this.backButton();
      }
    },

    quoteCustomer(debtor) {
      this.$utils.showLoading()
      return this.$store.dispatch('saveNewTable', {
        name: this.$store.getters.getOpenTableName,
        Customer: debtor.Id,
      }).then(() => this.$router.push({name: `tables`}))
          .finally(() => this.$utils.hideLoading())
    },

    printDebtorStatement(customerID) {
      this.loading = true
      return this.$store.dispatch(`printDebtorStatement`, customerID)
          .finally(() => this.loading = false)
    },


    createDebtor() {
      return this.$router.push({
        name: "create-debtor",
        query: {saleNumber: this.saleNumber}
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.search-box {
  position: sticky;
  background-color: white;
  top: 0;
  z-index: 1;
}

.col-md-4 {
  margin-bottom: 10px;

}
.text-sm{
  font-size: 12px;
}
</style>